import { Edit } from "@mui/icons-material";
import { alpha, Chip } from "@mui/material";
import Decimal from "decimal.js";
import { FunctionComponent } from "react";
import { MerchantType } from "../../../../../interfaces/delivery-company/merchants";
import { green } from "@mui/material/colors";

interface AmountChipProps {
    deltaCharge?: Decimal
    onClick: ()=>void
    readonly?: boolean
}
 
const AmountChip: FunctionComponent<AmountChipProps> = ({deltaCharge, onClick, readonly}) => {
    return <Chip
            icon={<Edit color='success' fontSize="small" />}
            label={
              deltaCharge
                ? <span style={{ color:'green'}}>{deltaCharge.toString()} $</span>
                : 'Default'
            }
            disabled={readonly}
            onClick={onClick}
            sx={{
              fontSize: '1.1rem',
              fontWeight: 600,
              height: 'auto',
              ...(deltaCharge && {
                border: '1px solid green', 
                background: alpha(green[100], 0.4), 
              }),
            }}
          />
}
 
export default AmountChip;